import { render, staticRenderFns } from "./paihangad-add-or-update.vue?vue&type=template&id=2924cc30"
import script from "./paihangad-add-or-update.vue?vue&type=script&lang=js"
export * from "./paihangad-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./paihangad-add-or-update.vue?vue&type=style&index=0&id=2924cc30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports